// extracted by mini-css-extract-plugin
export default {"switch":"SwitchField_switch__BkInh"};